import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SidebarService } from '../../services/sidebar.service';
import { NAV_ITEMS } from '../../nav-data';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, TranslatePipe],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  readonly items = NAV_ITEMS;

  constructor(public sidebarService: SidebarService) {}

  closeOnMobile(): void {
    if (window.innerWidth <= 860) {
      this.sidebarService.close();
    }
  }
}
